import styled from "styled-components";

export const StyledPageContent = styled.div`
  width: 100%;
  position: relative;
  transition: 300ms ease all;
`;
